var AVOID_SELECTOR = '.main-product__shop-bar, .main-product__shop-bar-content';
var AVOID_MIN_OVERLAP = 12;
var AVOID_TAIL_MS = 600;

function plMeasureAvoidOffset() {
  var offset = 0;
  var nodes;
  try {
    nodes = document.querySelectorAll(AVOID_SELECTOR);
  } catch (e) {
    return 0;
  }
  for (var i = 0; i < nodes.length; i++) {
    var el = nodes[i];
    var c = getComputedStyle(el);
    if (c.display === 'none' || c.visibility === 'hidden' || c.opacity === '0') continue;
    var r = el.getBoundingClientRect();
    if (r.width === 0 || r.height === 0) continue;
    var visible = Math.min(window.innerHeight, r.bottom) - Math.max(0, r.top);
    if (visible < AVOID_MIN_OVERLAP) continue;
    if (visible > offset) offset = visible;
  }
  return Math.round(offset);
}

var plOpticalNudge = 1; // px positivos deslocam o botão para a direita

function plAlignBackToTop() {
  var btt = document.querySelector('back-to-top');
  var chat = document.getElementById('vellor-chat-bubble');
  if (!btt || !chat) return;
  var chatRect = chat.getBoundingClientRect();
  var bttRect = btt.getBoundingClientRect();
  var gap = 16;
  var rightOffset = window.innerWidth - chatRect.right + (chatRect.width - bttRect.width) / 2 - plOpticalNudge;
  var chatBasedBottom = window.innerHeight - chatRect.top + gap;
  var avoidOffset = plMeasureAvoidOffset();
  var avoidBasedBottom = avoidOffset > 0 ? avoidOffset + gap : 0;
  var finalBottom = Math.max(chatBasedBottom, avoidBasedBottom);
  btt.style.right = rightOffset + 'px';
  btt.style.bottom = finalBottom + 'px';
}

var plTailUntil = 0;
function plPump() {
  plAlignBackToTop();
  if (performance.now() < plTailUntil) requestAnimationFrame(plPump);
}
function plSchedule() {
  plTailUntil = performance.now() + AVOID_TAIL_MS;
  requestAnimationFrame(plPump);
}

plAlignBackToTop();
window.addEventListener('load', plAlignBackToTop);
window.addEventListener('resize', plSchedule);
window.addEventListener('orientationchange', plSchedule);
window.addEventListener('scroll', plSchedule, { passive: true });

var plChatEl = document.getElementById('vellor-chat-bubble');
if (plChatEl) {
  new MutationObserver(plSchedule).observe(plChatEl, { attributes: true, attributeFilter: ['style', 'class'] });
  new ResizeObserver(plSchedule).observe(plChatEl);
}
new MutationObserver(plSchedule).observe(document.body, { attributes: true, attributeFilter: ['class'] });